import './Fader.css'

const DEFAULT_MIN_DB = -80
const DEFAULT_MAX_DB = 6

function sliderToDb(v: number, minDb: number, maxDb: number): number {
  if (v <= 0) return Number.NEGATIVE_INFINITY
  const shaped = Math.pow(v, 1 / 3) // audio taper: more resolution near unity
  return minDb + shaped * (maxDb - minDb)
}

function dbToSlider(db: number, minDb: number, maxDb: number): number {
  if (!Number.isFinite(db) || db <= minDb) return 0
  const norm = (db - minDb) / (maxDb - minDb)
  return Math.pow(norm, 3)
}

interface FaderProps {
  label: string
  db: number
  onChange: (db: number) => void
  disabled?: boolean
  onDoubleClick?: () => void
  minDb?: number
  maxDb?: number
  orientation?: 'vertical' | 'horizontal'
  showSolo?: boolean
  soloed?: boolean
  onSoloToggle?: () => void
}

export function Fader({
  label,
  db,
  onChange,
  disabled,
  onDoubleClick,
  minDb = DEFAULT_MIN_DB,
  maxDb = DEFAULT_MAX_DB,
  orientation = 'vertical',
  showSolo = false,
  soloed = false,
  onSoloToggle,
}: FaderProps) {
  const sliderValue = dbToSlider(db, minDb, maxDb)
  const display = !Number.isFinite(db) ? '-∞' : `${db.toFixed(1)} dB`

  return (
    <div className={`fader ${orientation === 'horizontal' ? 'fader--horizontal' : ''} ${disabled ? 'fader--disabled' : ''}`}>
      <div className="fader__meta">
        <div className="fader__label">{label}</div>
        <div className="fader__value">{display}</div>
        {showSolo && (
          <button
            type="button"
            className={`fader__solo ${soloed ? 'fader__solo--active' : ''}`}
            onClick={() => onSoloToggle?.()}
            aria-pressed={soloed}
            aria-label={`${label} solo`}
            disabled={disabled}
          >
            S
          </button>
        )}
      </div>
      <input
        type="range"
        min={0}
        max={1}
        step={0.001}
        value={sliderValue}
        onChange={e => onChange(sliderToDb(parseFloat(e.target.value), minDb, maxDb))}
        onDoubleClick={onDoubleClick}
        aria-label={`${label} level`}
        disabled={disabled}
      />
    </div>
  )
}
